import React, { Fragment } from 'react';
import Routes from '../../Routes';

const AppMain = () => {

    return (
        <Fragment>
            <Routes />
        </Fragment>
    )
};

export default AppMain;